import Vue from 'vue'

var resource = Vue.axiosFactory.create({baseURL: 'app/account/'})

export default {
  listUsers() {
    return resource({method: 'get', url: 'users'})
  },
  updateUserAuth(userId, allowedSystems) {
    return resource({method: 'post', url: 'update_user_auth', data: {userId, allowedSystems}})
  },
  addUser(user) {
    return resource({method: 'post', url: 'users', data: user})
  },
  removeUser(userId) {
    return resource({method: 'delete', url: 'users', data: {userId}})
  },
  listKeywords() {
    return resource({method: 'get', url: 'keywords'})
  },
  listFirstPageKeywords() {
    return resource({method: 'get', url: 'first_page_keywords'})
  },
  register(params) {
    return resource({method: 'post', url: 'register', data: params})
  },
  // createPotential(userData) {
  //   return resource({method: 'post', url: 'create_potential', data: {userData}})
  // },
  getActiveSubscription() {
    return resource({method: 'get', url: 'get_active_subscription'})
  },
  getCancelledSubscription() {
    return resource({method: 'get', url: 'get_cancelled_subscription'})
  },
  listPendingBusinessTasksArticles() {
    return resource({method: 'get', url: 'list_pending_business_tasks_articles'})
  },
  greet(accountId) {
    return resource({method: 'post', url: 'greet', data: {accountId}})
  },
  sendGMBDetails(info, filesData) {
    let formData = new FormData()
    let {photos, videos} = filesData

    Object.entries({photos, videos}).forEach(([key, val]) => {
      Object.keys(val).forEach((k) => {
        val[k].forEach((file, i) => {
          let extension = file.name.split('.').slice(-1)[0]
          formData.append('gmb', file, `${key}_${k}_${i}.${extension}`)
        })
      })
    })

    let { country_code: countryCode, number: phoneNumber } = info.basicInfo.businessPhone

    let infoToSend = JSON.parse(JSON.stringify(info))
    infoToSend.basicInfo.businessPhoneNumber = countryCode + phoneNumber
    delete infoToSend.basicInfo.businessPhone

    formData.append('gmb', new Blob([JSON.stringify(infoToSend, null, 2)], {
      type: 'application/json'
    }), 'info.txt')

    return resource({method: 'post', url: 'send_gmb_details', data: formData})
  }
}
